import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { tcsmColors } from '../../../global/constants/theme/theme-constants/colors';
import { DemographicsContext } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';

export const ClericIcon = () => {
    return (
        <svg className='clergy-icon' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.338 11.55C9.97801 9.35 6.81801 8 3.33801 8V19C6.81801 19 9.97801 20.35 12.338 22.55C14.698 20.36 17.858 19 21.338 19V8C17.858 8 14.698 9.35 12.338 11.55ZM12.338 8C13.998 8 15.338 6.66 15.338 5C15.338 3.34 13.998 2 12.338 2C10.678 2 9.33801 3.34 9.33801 5C9.33801 6.66 10.678 8 12.338 8Z" fill={tcsmColors.blue} />
        </svg>);
};

interface Props {
    shieldIcon?: boolean;
}

export const ClericIndicator = (props: Props) => {
    const app = useContext(DemographicsContext);
    const isPersonClergy = useSelector<TcsmStates, string>(state => state?.personalInfo[app]?.currentPerson?.cleric_in_book);
    const isEmployeeClergy = useSelector<TcsmStates, string>(state => state?.employmentState?.currentEmployee?.status);

    const renderIcon = () => {
        return props?.shieldIcon ?
            <>
                <svg className='clergy-icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
                </svg>
            </>
            : <ClericIcon />;
    };
    return (
        <>
            {
                isPersonClergy === 'Y' || isEmployeeClergy === 'Active Clergy' || isEmployeeClergy === 'Retired Clergy' ?
                    renderIcon()
                    : null
            }
        </>
    );
};

ClericIndicator.defaultProps = {
    shieldIcon: false,
};